console.log('hello beam');

//scrolling animation
var landingBlock = document.querySelector('.landing-block');
if (landingBlock) {

	// //fade out big logo
	// var controller = new ScrollMagic.Controller();
	// // build Tween
	// var tween = new TimelineMax()
	// 	.from(".hero-logo", 1.5, {opacity: 1})
	// 	.to(".hero-logo", 1.5, {opacity: 0, delay: 7});

	// // build scene
	// new ScrollMagic.Scene({
	// 	triggerElement: "#gsap-trigger",
	// 	triggerHook: "onEnter", // show, when scrolled 10% into view
	// 	duration: "100%", // use full viewport
	// 	offset: 50 // move trigger to center of element
	// })
	// .setTween(tween)
	// // .addIndicators({name: "GSAP"}) // add indicators (requires plugin)
	// .addTo(controller);

	//fade in small logo
	var logoController = new ScrollMagic.Controller();
	// build Tween
	var logoTween = new TimelineMax()
		.from(".hdr-logo-link", 1.5, {opacity: 0})
		.to(".hdr-logo-link", 1.5, {opacity: 1, delay: 7});

	// build scene
	new ScrollMagic.Scene({
		triggerElement: ".hero-logo",
		// triggerElement: "#gsap-trigger-2",
		triggerHook: "onLeave", // show, when scrolled 10% into view
		duration: "100%", // use full viewport
		offset: 95 // move trigger to center of element
	})
	.setTween(logoTween)
	// .addIndicators({name: "GSAP2"}) // add indicators (requires plugin)
	.addTo(logoController);

};
//end scrolling animation

//nav
const navControl = document.querySelector('.nav-control');

if (navControl) {
	navControl.addEventListener( 'click', () => {
		const menuHeader = document.querySelector('.js-header');
		const docBody = document.body;
		const footer = document.querySelector('.footer');

		// docBody.classList.toggle('modal-open');
		menuHeader.classList.toggle('visible');
		footer.classList.toggle('footer-z-index');

		if (menuHeader.classList.contains('visible')) {
			console.log('open nav');
			navControl.innerHTML = "Close";
		} else {
			console.log('close nav');
			navControl.innerHTML = "Menu";
		}

	} );
};

//close menu when links are clicked
const navAnchors = document.querySelectorAll('.nav-main a');
if (navAnchors) {
	navAnchors.forEach(navAnchor => {
		navAnchor.addEventListener( 'click', () => {
			const windowWidth = window.innerWidth;
			const menuHeader = document.querySelector('.js-header');
			if ((windowWidth < 1400) && (menuHeader.classList.contains('visible'))) {
				menuHeader.classList.toggle('visible');
				navControl.innerHTML = "Menu";
			};
		} );	
	});
};

const urlParams = new URLSearchParams(window.location.search);

if (urlParams.has('login') && ['empty', 'failed'.includes(urlParams.get('login'))]) {
	// OPEN MODAL HERE
	const associatedModal = document.getElementById('base-modal-2');

  	const docBody = document.body;
  	associatedModal.classList.remove( 'closed' );
  	associatedModal.classList.add( 'open' );
}







//sample modal
const modalControls = document.querySelectorAll('.modal-open-button');
const closeModalButtons = document.querySelectorAll('.close-modal');
const closeModalLogoLink = document.querySelectorAll('.hdr-logo-link-overlay');
const innerModalButtons = document.querySelectorAll('.inner-modal-button');
const modalMenu = document.querySelectorAll('.nav-modal a');

if (modalControls) {
	modalControls.forEach(modalButton => {

  		modalButton.addEventListener( 'click', (e) => {
			const modalNumber = modalButton.getAttribute('id').split('-').pop();
	  		const associatedModal = document.getElementById(`base-modal-${modalNumber}`);

  			const docBody = document.body;

  			docBody.classList.add( 'modal-open' );
  			associatedModal.classList.remove( 'closed' );
  			associatedModal.classList.add( 'open' );

  			console.log(e.target);

  			if (e.target.classList.contains('open-register-tab')) {
  				const loginTab = associatedModal.querySelector('.modal-tab-1');
  				const registerTab = associatedModal.querySelector('.modal-tab-2');
  				console.log(loginTab);
  				if(loginTab.classList.contains('open')) {
  					loginTab.classList.remove('open');
  					loginTab.classList.add('closed');
  					registerTab.classList.remove('closed');
  					registerTab.classList.add('open');
  				}
  			};

  		} );

	});
};

if (innerModalButtons) {
	innerModalButtons.forEach(innerModalButton => {
		innerModalButton.addEventListener( 'click', () => {
			const targetModalNumber = innerModalButton.getAttribute('id').split('-').pop();
			const associatedModal = document.getElementById(`base-modal-${targetModalNumber}`);
			const baseModal = document.querySelector('.base-modal.open');

			console.log(targetModalNumber);
			console.log(associatedModal);
			console.log(baseModal);
			baseModal.classList.remove( 'open' );
			baseModal.classList.add( 'closed' );
			associatedModal.classList.add( 'open' );
			associatedModal.classList.remove( 'closed' );
		});
	});
};

if (closeModalButtons) {
	closeModalButtons.forEach(closeModalButton => {
		closeModalButton.addEventListener( 'click', () => {
			const baseModal = document.querySelector('.base-modal.open');
			const docBody = document.body;
			docBody.classList.remove( 'modal-open' );
			baseModal.classList.add( 'closed' );
			baseModal.classList.remove( 'open' );
		} );
	});
};

if (closeModalLogoLink) {
	closeModalLogoLink.forEach(closeModalButton => {
		closeModalButton.addEventListener( 'click', () => {
			const baseModal = document.querySelector('.base-modal.open');
			const docBody = document.body;
			docBody.classList.remove( 'modal-open' );
			baseModal.classList.add( 'closed' );
			baseModal.classList.remove( 'open' );
		} );
	});
};

if (modalMenu) {
	modalMenu.forEach(menuLink =>  {
		menuLink.addEventListener( 'click', () => {
			console.log('clicked menu link');
			const baseModal = document.querySelector('.base-modal.open');
			const docBody = document.body;
			docBody.classList.remove( 'modal-open' );
			baseModal.classList.add( 'closed' );
			baseModal.classList.remove( 'open' );
		} );
	});
};

//modal tabs

const tabControls = document.querySelectorAll('.tab-control');
if (tabControls) {
	tabControls.forEach(tabControl =>  {
		tabControl.addEventListener( 'click', () => {
			const tabNumber = tabControl.getAttribute('id').split('-').pop();
	  		const associatedTab = document.getElementById(`modal-tab-${tabNumber}`);
	  		const currentTab = document.querySelector('.modal-tab.open');

	  		console.log('clicked tab contron')
	  		console.log(tabNumber)
	  		console.log(associatedTab)
	  		console.log(currentTab)


  			associatedTab.classList.remove( 'closed' );
  			associatedTab.classList.add( 'open' );
  			currentTab.classList.add( 'closed' );
  			currentTab.classList.remove( 'open' );

  		} );
	});
};









//accordions
const accordionButtons = document.querySelectorAll('.accordion__button');
const accordionSections = document.querySelectorAll('.accordion__section');

accordionSections.forEach(section =>  {
  section.setAttribute('aria-hidden', true)
  section.classList.remove('open')
})

accordionButtons.forEach(button => {
  button.setAttribute('aria-expanded', false);
  
  const expanded = button.getAttribute('aria-expanded');
  const number = button.getAttribute('id').split('-').pop();
  const associatedSection = document.getElementById(`accordion-section-${number}`)
  const associatedWrapper = document.getElementById(`diamond-accordion-wrapper-${number}`)
 
  button.addEventListener('click', () => {
    console.log('button clickèd');
    button.classList.toggle('expanded');
    associatedSection.classList.toggle('open');
    associatedWrapper.classList.toggle('open');
    if (button.classList.contains('expanded')) {
      button.setAttribute('aria-expanded', true);
      associatedSection.setAttribute('aria-hidden', false);
    } else {
      button.setAttribute('aria-expanded', false);
      associatedSection.setAttribute('aria-hidden', true);
    }
  })
})


//accordions
const settingAccordionButton = document.querySelectorAll('.settings-accordion-button');
const settingAccordionSection = document.querySelectorAll('.settings-accordion-content');


settingAccordionSection.forEach(section =>  {
  section.setAttribute('aria-hidden', true)
  section.classList.remove('open')
})

settingAccordionButton.forEach(button => {
  button.setAttribute('aria-expanded', false);
  
  const expanded = button.getAttribute('aria-expanded');
  const number = button.getAttribute('id').split('-').pop();
  const associatedSection = document.getElementById(`settings-accordion-content-${number}`)
 
  button.addEventListener('click', () => {
    console.log('button clickèd');
    button.classList.toggle('expanded');
    associatedSection.classList.toggle('open');
    if (button.classList.contains('expanded')) {
      button.setAttribute('aria-expanded', true);
      associatedSection.setAttribute('aria-hidden', false);
    } else {
      button.setAttribute('aria-expanded', false);
      associatedSection.setAttribute('aria-hidden', true);
    }
  })
})

//select diamonds interaction
let selectedDiamonds = [];
// const selectDiamondCheckbox = document.querySelectorAll('.select-diamond-input');
// selectDiamondCheckbox.forEach(checkbox => {
// 	const diamondId = checkbox.dataset.diamondId;
// 	checkbox.addEventListener('click', () => {
// 		// console.log('clicked checkbox ' + diamondId);
// 		if (checkbox.checked) {
// 			console.log('checked')
// 			selectedDiamonds.push(diamondId);
// 		} else {
// 			console.log('not checked ok')
// 			// selectedDiamonds.filter(function(e) { return e !== diamondId })
// 			selectedDiamonds.indexOf(diamondId) !== -1 && selectedDiamonds.splice(selectedDiamonds.indexOf(diamondId), 1)
// 		};
// 		console.log(selectedDiamonds);
// 	});
// }); 

//select visible
		// const selectVisibleButton = document.querySelectorAll('.diamond-select-all');
		// selectVisibleButton.forEach(button => { 
		// 	button.addEventListener('click', () => {
		// 		console.log('get all visible diamonds');
		// 		selectDiamondCheckbox.forEach(checkbox => {
		// 			const diamondId = checkbox.dataset.diamondId;
		// 			if (!selectedDiamonds.includes(diamondId)) {
		// 				selectedDiamonds.push(diamondId);
		// 			};
		// 		});
		// 		console.log(selectedDiamonds);
		// 	});
		// });

//populate diamond modal
const diamondSelectedList = document.querySelector('.select-diamond-list');
const exportButton = document.querySelector('.export-selected-diamonds');

if (exportButton) {
	exportButton.addEventListener('click', () => {
		const diamondUl = `<ul>
		${selectedDiamonds.map( diamond => `<li data-diamond-id="${diamond}">${diamond}<button class="remove-from-array">Remove</button></li>`).join('')}
		</ul>

		`;

		diamondSelectedList.innerHTML = diamondUl;

		const removeDiamondFromModalButton = document.querySelectorAll('.remove-from-array');
		removeDiamondFromModalButton.forEach(button => {
			button.addEventListener('click', () => {
				const selectedListItem = event.target.parentNode;
				const selectedListItemId = selectedListItem.dataset.diamondId;
				console.log('clicked remove button');
				console.log(selectedListItem);
				//remove from array
				selectedDiamonds.indexOf(selectedListItemId) !== -1 && selectedDiamonds.splice(selectedDiamonds.indexOf(selectedListItemId), 1)
				console.log(selectedDiamonds);
				selectedListItem.remove();
				

			});
		}); 	
	});	
	
};


const closeDiamondModal = document.querySelector('.close-selected-diamond-modal');
if (closeDiamondModal) {
	closeDiamondModal.addEventListener('click', () => {
		diamondSelectedList.innerHTML = ""
		const selectDiamondCheckbox = document.querySelectorAll('.select-diamond-input');

		selectDiamondCheckbox.forEach(checkbox => {
					const diamondId = checkbox.dataset.diamondId;

					if (selectedDiamonds.includes(diamondId)) {
						checkbox.checked = true;
					} else {
						checkbox.checked = false;
					};
				});
	});
};


//settings sliders
var caratSlider = document.getElementById('carat-slider');
var caratMinInput = document.getElementById('carat-min-input');
var caratMaxInput = document.getElementById('carat-max-input');
var inputs = [caratMinInput, caratMaxInput];

if (caratSlider) {
	noUiSlider.create(caratSlider, {
	    start: [0, 12],
	    step: 0.01,
	    range: {
	        'min': 0,
	        'max': 12
	    },
	    connect: true,
	    pips: {
	    	mode: 'values',
	        values: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
	        // values: [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20],
	        // values: [0, 5, 10, 15],
	        density: 6,
	        stepped: true
	    }
	});
	
	caratSlider.noUiSlider.on('update', function (values, handle) {
    	inputs[handle].value = values[handle];
	});
};

if (caratMinInput && caratMaxInput) {
	console.log('got carats');
	// caratMinInput.addEventListener('input', () => {
	// 	const caratMinValue = caratMinInput.value;
	// 	console.log(caratMinValue);
	// 	caratSlider.noUiSlider.set([caratMinValue, null]);
	// })
	// caratMaxInput.addEventListener('input', () => {
	// 	const caratMaxValue = caratMaxInput.value;
	// 	console.log(caratMaxValue);
	// 	caratSlider.noUiSlider.set([null, caratMaxValue]);
	// })
	inputs.forEach(function (input, handle) {

	    input.addEventListener('change', function () {
	        caratSlider.noUiSlider.setHandle(handle, this.value);
	    });

	    input.addEventListener('keydown', function (e) {

	        var values = caratSlider.noUiSlider.get();
	        var value = Number(values[handle]);

	        // [[handle0_down, handle0_up], [handle1_down, handle1_up]]
	        var steps = caratSlider.noUiSlider.steps();

	        // [down, up]
	        var step = steps[handle];

	        var position;

	        // 13 is enter,
	        // 38 is key up,
	        // 40 is key down.
	        switch (e.which) {

	            case 13:
	                caratSlider.noUiSlider.setHandle(handle, this.value);
	                break;

	            case 38:

	                // Get step to go increase slider value (up)
	                position = step[1];

	                // false = no step is set
	                if (position === false) {
	                    position = 1;
	                }

	                // null = edge of slider
	                if (position !== null) {
	                    caratSlider.noUiSlider.setHandle(handle, value + position);
	                }

	                break;

	            case 40:

	                position = step[0];

	                if (position === false) {
	                    position = 1;
	                }

	                if (position !== null) {
	                    caratSlider.noUiSlider.setHandle(handle, value - position);
	                }

	                break;
	        }
	    });
	});
};

var colorSlider = document.getElementById('color-slider');

if (colorSlider) {
	var colorArr = ['D', 'E', 'F', 'G', 'H', 'I', 'J'];

	noUiSlider.create(colorSlider, {
	    start: [4, 10],
	    step: 1,
	    range: {
	        'min': [4],
	        'max': [10]
	    },
	    connect: true,
	    pips: {
	    	mode: 'steps',
		    filter: function(value, type) {
			    return value % 1 ? -1 : 2;
			},
			format: {
		        // 'to' the formatted value. Receives a number.
		        to: function (value) {
		            return colorArr[(value - 4)];
		        },
		        // 'from' the formatted value.
		        // Receives a string, should return a number.
		        from: function (value) {
		        	return colorArr.indexOf(value);
		        }
		    }
	    }
	});
};


//screensaver 
//https://stackoverflow.com/questions/667555/how-to-detect-idle-time-in-javascript

// var inactivityTime = function () {
//     var time;
//     window.onload = resetTimer;
//     // DOM Events
//     document.onmousemove = resetTimer;
//     document.onkeydown = resetTimer;

//     function logout() {
//         const screensaver = document.querySelector('.screensaver');
//         screensaver.classList.add('visible');
//     }

//     function resetTimer() {
//         clearTimeout(time);
//         time = setTimeout(logout, 600000)
//         // 1000 milliseconds = 1 second
//     }
// };

// window.onload = function() {
// 	inactivityTime();
// }

// document.addEventListener( 'mousemove', () => {
// 	console.log('mousemove');
// 	const screensaver = document.querySelector('.screensaver');
// 	if (screensaver) {
// 		if (screensaver.classList.contains('visible')) {
// 			screensaver.classList.remove('visible')
// 		};
// 	};
// } );

//nav scroll effect

// https://stackoverflow.com/questions/54866560/same-intersection-observer-for-multiple-html-elements
// https://css-tricks.com/an-explanation-of-how-the-intersection-observer-watches/
//https://www.smashingmagazine.com/2021/07/dynamic-header-intersection-observer/
//https://github.com/mbarker84/smashing-io-header/blob/master/src/index.js

const header = document.querySelector('[data-header]')
const sections = [...document.querySelectorAll('[data-section]')]
const headerLinks = [...document.querySelectorAll('[data-link]')]

let prevYPosition = 0
let direction = 'up'

const options = {
	rootMargin: `${header.offsetHeight * -1}px`,
	threshold: 0
}

const getTargetSection = (entry) => {
	const index = sections.findIndex((section) => section == entry.target)

	if (index >= sections.length - 1) {
	 return entry.target
	} else {
	 return sections[index + 1]
	}
}

const updateColors = (target) => {
	const theme = target.dataset.section
	header.setAttribute('data-theme', theme)
}

const shouldUpdate = (entry) => {
	if (direction === 'down' && !entry.isIntersecting) {
		return true
	}

	if (direction === 'up' && entry.isIntersecting) {
		return true
	}

	return false
}

// const updateMarker = (target) => {
// 	const id = target.id

// 	if (!id) return

// 	let link = headerLinks.find((el) => {
// 		return el.getAttribute('href') === `#${id}`
// 	})

// 	link = link || headerLinks[0]

// 	const distanceFromLeft = link.getBoundingClientRect().left

// 	header.style.setProperty('--markerWidth', `${link.clientWidth}px`)
// 	header.style.setProperty('--markerLeft', `${distanceFromLeft}px`)
// }

const onIntersect = (entries) => {
	entries.forEach((entry) => {
		if (window.scrollY > prevYPosition) {
			direction = 'down'
		} else {
			direction = 'up'
		}

		prevYPosition = window.scrollY

		const target = direction === 'down' ? getTargetSection(entry) : entry.target

		if (shouldUpdate(entry)) {
			updateColors(target)
			// updateMarker(target)
		}
	})
}

document.addEventListener('readystatechange', e => {
  if (e.target.readyState === 'complete') {
    // updateMarker(sections[0])
  }
})

const observer = new IntersectionObserver(onIntersect, options)

sections.forEach((section) => {
	observer.observe(section)
})


//add placeholder to gravity forms
const nameInput = document.querySelector('.modal-content .gf_login_form #input_1');
const passInput = document.querySelector('.modal-content .gf_login_form #input_2');
if (nameInput) {
	nameInput.placeholder = "Username"; 
};
if (passInput) {
	passInput.placeholder = "Password"; 
};

// form submission
const diamondForm = document.querySelector('.select-diamond-form');
if (diamondForm) {
    diamondForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const worker = new Worker( `${beam_urls.themeUrl}/assets/js/inventory-filter-worker.min.js` );
        const email = document.getElementById('diamond-email').value;
        const emailMsg = document.getElementById('diamond-msg').value;
        // const list = document.getElementById('diamond-list');
        const selectedDiamondsString = selectedDiamonds.toString();
        const list = selectedDiamondsString;
        const price = diamondForm.classList.contains('user-price');
        const noPrice = diamondForm.classList.contains('user-no-price');

        if (noPrice) {
        	console.log('no price');
        	worker.postMessage({
	        	action: 'findDiamondsByIds',
		    	config: JSON.stringify( { ids: selectedDiamonds } ),
		    	stringifiedItems: beam_urls.selectedCsvSourceNp,
	        });
        } else if (price) {
        	console.log('price');
        	worker.postMessage({
	        	action: 'findDiamondsByIds',
		    	config: JSON.stringify( { ids: selectedDiamonds } ),
		    	stringifiedItems: beam_urls.selectedCsvSource,
	        });
        } else {
        	console.log('price with else');
	        worker.postMessage({
	        	action: 'findDiamondsByIds',
		    	config: JSON.stringify( { ids: selectedDiamonds } ),
		    	stringifiedItems: beam_urls.selectedCsvSource,
	        });
        };

        worker.onmessage = ( { data } ) => {
        	// const selectedDiamondsArray = [{"inventory":"diabon","shape":"round","availability":"Available","weight":"4.150","color":"7","clarity":"7","cut":"id","cert":"536289707","total":"7755.31","measurements":"10.37 x 10.40 x 6.27","polish":"EX","symmetry":"EX","depth":"60.40","table":"58.50","vendor_stock_number":"D141544","thumbnail":"","asking_price":"32500.00","discount":"-94.250","video_link":"https:\/\/v360.in\/movie\/1438_141544"},{"inventory":"diabon","shape":"oval","availability":"Available","weight":"3.610","color":"8","clarity":"7","cut":"uncategorized","cert":"524238589","total":"4873.50","measurements":"12.67 x 8.80 x 5.36","polish":"EX","symmetry":"EX","depth":"60.90","table":"60.00","vendor_stock_number":"D134024","thumbnail":"","asking_price":"18000.00","discount":"-92.500","video_link":"https:\/\/v360.in\/movie\/1438_134024"}];
	        const csvArray = data.items;

	        console.log('csvArray',csvArray);

	        const emailData = {
	            'action': 'formdata',
	            'fields': JSON.stringify({
	                email,
	                emailMsg,
	                list,
	                csvArray
	            }), 
	        };

	        const httpRequest = new XMLHttpRequest();

	        if (!httpRequest) {
	            alert('Giving up :( Cannot create an XMLHTTP instance');
	            return false;
	        }
	        httpRequest.onreadystatechange = alertContents;
	        httpRequest.open('POST', diamondModalAjax.url);
	        httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	        httpRequest.send(Object.keys(emailData).map(key => key + '=' + emailData[key]).join('&'));



	        function alertContents() {
	            if (httpRequest.readyState === XMLHttpRequest.DONE) {
	                if (httpRequest.status === 200) {
	                    console.log('success sent');
	                    console.log(httpRequest.status);
	                    const response = httpRequest.responseText;
	                    // const response = JSON.parse(httpRequest.responseText);
	                    console.log(response);

	                    //close newsletter modal
	                    const diamondModal = document.querySelector( '.base-modal-5' );
	                    const docBody = document.body;


	                    diamondModal.classList.remove('open');
	                    diamondModal.classList.add('closed');
	  					docBody.classList.remove( 'modal-open' );
	                    
	                } else {
	                    // const submitError = document.querySelector( '.p-newsletter-error' );
	                    // newsLetterSuccess.classList.add('display-error');
	                    
	                    console.log('failure.');
	                    console.log(emailData);
	                    console.log(selectedDiamondsString);
	                }
	            }
	        }
		};

		worker.onerror = ( error ) => {
			console.log( 'Worker error (' + data.action + '): ' + error.message + '\n' );
			throw error;
		};

    });
};